import ExemptionCreate from '../../views/exemption/ExemptionCreate';
import ExemptionAppreciation from '../../views/exemption/ExemptionAppreciation';
import ExemptionList from '../../views/exemption/ExemptionList';
import ExemptionBoard from '../../views/exemption/ExemptionBoard';
import ExemptionEmployeeEdit from '../../views/exemption/ExemptionEmployeeEdit';
import ExemptionEmployeeInit from '../../views/exemption/ExemptionEmployeeInit';
import ExemptionEdit from '../../views/exemption/ExemptionEdit';
import ExemptionSearch from '../../views/exemption/ExemptionSearch';
import ExemptionUpdate from '../../views/exemption/ExemptionUpdate';
import ManualSettings from '../../views/ManualSettings.vue';
import ExemptionRenew from '../../views/exemption/ExemptionRenew';
import { isCanAction, isCanViewExemptions, isCanEditExemptions } from '@/router/permission';

export default [
    {
        path: '/exemption/create',
        name: 'exemption-create',
        component: ExemptionCreate,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanAction
    },
    {
        path: '/exemption/:id/appreciation',
        name: 'exemption-appreciation',
        component: ExemptionAppreciation,
        meta: { isAuthRequired: true, isEnterpriseRequired: true }
    },
    {
        path: '/exemption/list',
        name: 'exemption-list',
        component: ExemptionList,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanViewExemptions
    },
    {
        path: '/exemption/enterprises-list',
        name: 'exemption-enterprises-list',
        component: ExemptionBoard,
        meta: { isAuthRequired: true, showIfEnterpriseSelected: false },
        beforeEnter: isCanViewExemptions
    },
    {
        path: '/exemption/init/:clientSlug/:exemptionInitToken',
        name: 'employee-exemption-init',
        component: ExemptionEmployeeInit,
    },
    {
        path: '/exemption/:exemptionAccessToken/employee-edit',
        name: 'employee-exemption-edit',
        component: ExemptionEmployeeEdit,
    },
    {
        path: '/exemption/:exemptionId/edit',
        name: 'exemption-edit',
        component: ExemptionEdit,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanAction
    },
    {
        path: '/exemption/:exemptionId/renew',
        name: 'exemption-renew',
        component: ExemptionRenew,
        meta: { isAuthRequired: true, isEnterpriseRequired: true }
    },
    {
        path: '/exemption/:exemptionId/update',
        name: 'exemption-update',
        component: ExemptionUpdate,
        meta: { isAuthRequired: true },
        beforeEnter: isCanEditExemptions
    },
    {
        path: '/exemption/search',
        name: 'exemption-search',
        component: ExemptionSearch,
        meta: { isAuthRequired: true },
        beforeEnter: isCanViewExemptions
    },
    {
        path: '/manual-settings',
        name: 'manual-settings',
        component: ManualSettings,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
    }
];